module.exports = __webpack_public_path__ + "32f9e3faee8a626ad444a75b17c64e20.pdf";